module.exports = __webpack_public_path__ + "static/hackademic-709a6c7e2c27b85f3934f776f7272d58.png";